import InvoiceIcon from './invoice-icon';

const filesIcons = { InvoiceIcon };

export default filesIcons;
